import { useQuery } from '@apollo/client';
import { InvalidZipCodeError } from 'utils/errors/client-errors';
import { GET_UTILITIES_BY_ZIP } from './add-moving-details.api';

export const useUtilitiesByZip = (zipCode, validZipCodeLength) => {
  const { data, loading, error } = useQuery(GET_UTILITIES_BY_ZIP, {
    skip: !validZipCodeLength,
    variables: { zipCode },
  });

  const result = data?.utilitiesByZip;

  let invalidZipCodeError;
  if (!loading && validZipCodeLength && !result?.suggested.length) {
    invalidZipCodeError = new InvalidZipCodeError();
  }

  return { data: result, error: error || invalidZipCodeError, loading };
};
